module.exports = __webpack_public_path__ + "static/media/icon_210.2b030d28.svg";